export default __webpack_public_path__ + "static/media/2227.46f82998.png";